import { UserCheck } from "lucide-react";

/**
 * Badge shown on any lead where the Gingr owner was created *after* the lead
 * (within 14 days). Signals that the customer self-registered in response to
 * our automated onboarding email — a very high-intent state that staff should
 * action ASAP.
 *
 * Sizes: sm (kanban / list rows), md (queue cards), lg (detail header).
 */
export default function SelfRegisteredBadge({ size = "sm", className = "", withPulse = false }) {
  const dims = {
    sm: "text-[10px] px-1.5 py-0.5 gap-1",
    md: "text-[11px] px-2 py-0.5 gap-1",
    lg: "text-xs px-2.5 py-1 gap-1.5",
  }[size] || "text-[10px] px-1.5 py-0.5 gap-1";

  const iconSize = { sm: "w-3 h-3", md: "w-3.5 h-3.5", lg: "w-4 h-4" }[size] || "w-3 h-3";

  return (
    <span
      className={`inline-flex items-center font-bold rounded-full text-white shadow-sm bg-gradient-to-r from-emerald-500 to-teal-600 whitespace-nowrap ${dims} ${className}`}
      title="Customer self-registered on Gingr after our welcome email — hot lead, ready to book"
      data-testid="self-registered-badge"
    >
      {withPulse && (
        <span className="relative flex h-1.5 w-1.5 mr-0.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white" />
        </span>
      )}
      <UserCheck className={iconSize} />
      Self-Registered
    </span>
  );
}
